
import React from "react";
import PageDesign from "../../../../../page_design/PageDesign";
import { i18nManager } from "../../../../../../i18n";
import { Siren } from "../../../../../shared/ConfirmDialog";
import { BaseService, HostService, ITournamentEdition, ITournamentEditionWebsite, IMember, SanitizedResponse, TournamentService } from "../../../../../../services";

export interface DesignProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function Design(props: DesignProps) {

    const hostService = HostService.getInstance();
    const tournamentService = TournamentService.getInstance();
    const [tournamentEditionWebsite, setTournamentEditionWebsite] = React.useState<ITournamentEditionWebsite>(props.tournamentEditionWebsite);

    return (<div className="profile-settings team-settings"><PageDesign publicId={props.tournamentEdition.meta.public_id} designType={"tournament"} activeDesign={props.tournamentEditionWebsite.website_design_settings} onUpdate={updateDesign} searchParams={{
        edition: props.tournamentEdition.external_id,
    }}/></div>);

    function updateDesign(pageDesign: any, onDone?: () => void) {
        if (!tournamentEditionWebsite) return onDone?.();
        tournamentEditionWebsite.website_design_settings = pageDesign;
        tournamentService.updateTournamentEditionWebsite(props.tournamentEdition.external_id, { ...tournamentEditionWebsite }).then(({ sanitized }: SanitizedResponse<ITournamentEditionWebsite>) => {
            setTournamentEditionWebsite(sanitized);
            Siren.alert(i18nManager.Labels.host.manage_tournament.settings.website.design_update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Design;
